import React from "react";
import { AdvanceOutletInvoicingJson } from "../../../DynamicFormsJson/Transaction/advanceOutletInvoicing";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";

const AdvanceOutletInvoicingSearchPanel = ({
  formData,
  dynamicMasterData,
  searchList,
  onGetListById,
  onSearch,
  onSearchList,
  onGetData,
}) => (
  <DynamicMainScreen
      formData={formData}
      callApi={false}
      showPdfDownload={false}
      showExcelDownload={false}
      showAddButton={false}
      getListById={onGetListById}
      dynamicMasterData={dynamicMasterData}
      showTitle={AdvanceOutletInvoicingJson.showTitle}
      screenTitle={AdvanceOutletInvoicingJson.screenTitle}
      searchList={searchList}
      searchTrue={false}
      onFilterData={onSearch}
      apiBaseURL={AdvanceOutletInvoicingJson.apiBaseURL}
      showSaveNextBtn={false}
      showSaveBtnMain={false}
      showSaveBtn={true}
      saveBtnText="Search"
      onSearchData={onSearchList}
      padding={true}
      paddingTop={true}
      resetAfterSave={false}
      getTableData={onGetData}
    />
);

export default React.memo(AdvanceOutletInvoicingSearchPanel);
